import React, { useEffect, useState } from 'react';
import request from '../../utils/request';
import loader from '../common/loader.gif';
import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

function QcEndorsementView({ endoresementData }) {
  const [loadingMain, setLoadingMain] = useState(false);
  const [previewData, setPreviewData] = useState<string | null>(null);

  useEffect(() => {
    fetchPolicyDetails();
  }, []);

  const fetchPolicyDetails = () => {
    setLoadingMain(true);

    request({
      url: 'insurancePolicy/getPolicyById',
      method: 'post',
      data: { policyId: endoresementData?.policyId }
    }).then(
      (response) => {
        request({
          url: 'endorsement/getEndorsementMailPreview',
          method: 'post',
          data: {
            ids: [endoresementData.id],
            type: 'QC',
            insuranceCompanyId: response?.data?.insuranceCompany?.id,
            insuranceCompanyBranchId:
              response?.data?.insuranceCompanyBranch?.id,
            insuranceCompanyBranchContact: null,
            otherContact: response?.data?.insuranceCompanyBranch?.email,
            showButton: false
          }
        }).then(
          (res: any) => {
            setPreviewData(res);
            setLoadingMain(false);
          },
          () => setLoadingMain(false)
        );
      },
      () => setLoadingMain(false)
    );
  };

  /* -------------------- LOADER -------------------- */
  if (loadingMain) {
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <img alt="loader" src={loader} width={100} height={100} />
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
    );
  }

  /* -------------------- QC VIEW -------------------- */
  return (
    <Box
      sx={{
        width: '100%',
        height: 'calc(100vh - 64px)',
        overflow: 'hidden',
        backgroundColor: '#fff'
      }}
    >
      <iframe
        title="QC Endorsement Preview"
        srcDoc={`
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<style>
  /* ---------- SCREEN ---------- */
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  body {
    overflow-y: auto;
    font-family: Arial, sans-serif;
  }

  table {
    width: 100% !important;
    border-collapse: collapse;
  }

  /* ---------- PRINT ---------- */
  @media print {
    html, body {
      height: auto !important;
      overflow: visible !important;
    }

    * {
      overflow: visible !important;
    }

    table {
      page-break-inside: auto;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    @page {
      size: A4;
      margin: 15mm;
    }
  }
</style>
</head>
<body>
${previewData || ''}
</body>
</html>
        `}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          overflow: 'hidden'
        }}
      />
    </Box>
  );
}

export default QcEndorsementView;
